import { render, staticRenderFns } from "./data30.vue?vue&type=template&id=6391aff8&scoped=true&"
import script from "./data30.vue?vue&type=script&lang=js&"
export * from "./data30.vue?vue&type=script&lang=js&"
import style1 from "./data30.vue?vue&type=style&index=1&id=6391aff8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6391aff8",
  null
  
)

export default component.exports